export const linkResolver = (doc: any) => {
  // Pretty URLs for known types
  if (doc.type === 'post') return `/blog/${doc.uid}`;
  if (doc.type === 'page') return `/page/${doc.uid}`;
  // Fallback for other types, in case new custom types get created
  return `/${doc.id}`;
};
